import { useState } from "react";
import { Film, Play } from "lucide-react";
import { VideoLightbox } from "@/components/site/Portfolio";

const TIERS = ["Simple", "Complex", "Complex", "Premium"];

const ReelCard = ({ item, dup, onOpen }) => (
  <button type="button" onClick={() => onOpen(item)} tabIndex={dup ? -1 : undefined} aria-label={`Play ${item.title}`} className="group relative block text-left w-[200px] sm:w-[240px] aspect-[9/16] shrink-0 overflow-hidden bg-[#121212] border border-[#27272A] hover:border-[#0055FF]" data-testid={dup ? undefined : `reel-card-${item.slug}`}>
    {item.thumbnail_url && <img src={item.thumbnail_url} alt={item.title} loading="lazy" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />}
    <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/10 to-transparent" />
    <span className="absolute top-3 right-3 w-9 h-9 flex items-center justify-center bg-black/60 backdrop-blur group-hover:bg-[#0055FF] transition-colors"><Play size={14} /></span>
    <div className="absolute bottom-0 inset-x-0 p-4">
      {item.tier && <p className="text-[10px] tracking-[0.25em] font-bold text-[#00E5FF]">{item.tier.toUpperCase()}</p>}
      <p className="mt-1 text-sm font-semibold text-white line-clamp-2">{item.title}</p>
    </div>
  </button>
);

const PlaceholderCard = ({ i, dup }) => (
  <div className="relative w-[200px] sm:w-[240px] aspect-[9/16] shrink-0 border border-dashed border-[#0055FF]/40 bg-gradient-to-b from-[#0a0f1f] to-[#050505] flex flex-col items-center justify-center gap-3 text-center px-6" data-testid={dup ? undefined : `reel-placeholder-${i}`} aria-label="Video slot awaiting upload">
    <Film size={28} className="text-[#0055FF]/70" />
    <p className="text-[10px] tracking-[0.25em] font-bold text-[#00E5FF]/80">{TIERS[i % TIERS.length].toUpperCase()}</p>
    <p className="text-xs text-zinc-500">Reel slot — video coming soon</p>
  </div>
);

export const Showreel = ({ items, slots = 8, placeholders = true }) => {
  const [open, setOpen] = useState(null);
  const fill = placeholders ? Math.max(0, slots - items.length) : 0;
  const make = (dup) => [...items.map((it) => <ReelCard key={it.id} item={it} dup={dup} onOpen={setOpen} />), ...Array.from({ length: fill }).map((_, i) => <PlaceholderCard key={`p${i}`} i={i + items.length} dup={dup} />)];
  const cards = make(false);
  if (!cards.length) return null;
  const animate = cards.length >= 4;
  return (
    <div className="relative overflow-hidden eb-marquee-mask" data-testid="showreel">
      <div className={`flex gap-4 w-max ${animate ? "eb-marquee" : ""}`}>
        {cards}
        {animate && <div className="flex gap-4" aria-hidden="true" inert>{make(true)}</div>}
      </div>
      <VideoLightbox item={open} onClose={() => setOpen(null)} />
    </div>
  );
};
